import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const lockPositionMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: ({ refMap }): string => {
			const isLocked = refMap?.panelItemGroup?.positionLocked ?? false;
			return isLocked ? 'Unlock position' : 'Lock position';
		},
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap }): void => {
			if (refMap && refMap.panelItemGroup) {
				refMap.panelItemGroup.positionLocked = !refMap.panelItemGroup.positionLocked;
			}
		}
	};
};
